import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import BarBlock from './BarBlock'
import AjaxLoader from './AjaxLoader'

const HomeSecureCategoriesBlocked = (props) => {
    const [highestValue, setHighestValue] = useState({})

    useEffect(() => {
        calcPercentages()
    }, [props.categories])

    const calcPercentages = () => {
        let topValue = 0
        Object.keys(props.categories).forEach(title => {
            const value = parseInt(props.categories[title])
            if (value > topValue) {
                topValue = value
            }
        })

        setHighestValue(topValue)
    }

    const calcWidth = count => {
        return (count / highestValue) * 100
    }

    const Categories = () => {
        if (Object.keys(props.categories).length === 0) {
            return <p className='text-center'>There are currently no results to show for this time frame.</p>
        }

        return Object.keys(props.categories).map(title => {
            const value = props.categories[title]
            return <BarBlock key={title} title={title} width={calcWidth(value)} count={value} />
        })
    }

    return (
        <div className='row'>
            <div className='col-12 col-md-8 offset-md-2 text-center mb-5'>
                {props.children}
            </div>
            <div className='col-12 col-md-8 offset-md-2 d-flex mb-4 mb-lg-5 justify-content-center flex-column'>
                {props.isLoadingDuration ? <AjaxLoader /> : Categories()}
            </div>
            {!props.isLoadingDuration &&
                <div className='col-12 col-lg-10 offset-lg-1 text-center'>
                    <p className='m-0 mb-2 bold lh'>{props.duration === 'last30d' ? 'This report is updated daily @ 12AM' : 'This report is updated hourly'}</p>
                    <p className='m-0 lh'>
                        Many websites often include multiple hidden requests for content that take place in the background, without you even noticing. This means that each time you are blocked from visiting a website, Home Secure actually blocks several pages and requests made by the domain in the background. As a result, the total number of blocking events shown here is much higher than the number of blocked website messages you are shown while browsing. Enabling Safe Search will also generate significantly higher levels of background blocking events for categories such as ‘Search Engines’ blocks that will report here.
                    </p>
                </div>}
        </div>
    )
}

HomeSecureCategoriesBlocked.propTypes = {
    categories: PropTypes.object.isRequired,
    isLoadingDuration: PropTypes.bool,
    duration: PropTypes.oneOf(['last24h', 'last7d', 'last30d'])
}

HomeSecureCategoriesBlocked.defaultProps = {
    categories: []
}

export default HomeSecureCategoriesBlocked



// WEBPACK FOOTER //
// ./resources/js/components/HomeSecureCategoriesBlocked.js